module.exports = __webpack_public_path__ + "img/electro-harmonix-soul-food.0b8d868d.jpg";